var map = {
	"./desk-slider/Naina banner 1.jpg": 1857,
	"./desk-slider/Naina banner 2.jpg": 1219,
	"./desk-slider/Naina banner 3.jpg": 7483,
	"./desk-slider/Naina banner 4.jpg": 7490,
	"./desk-slider/Rudra 5 inch.webp": 4205,
	"./desk-slider/Vama banner 1.jpg": 4725,
	"./desk-slider/Vama banner 2.jpg": 4389,
	"./desk-slider/Vama banner 3.jpg": 3515,
	"./desk-slider/ds1.jpg": 9981,
	"./desk-slider/ds2.jpg": 4475,
	"./desk-slider/ds3.jpg": 4459,
	"./desk-slider/ds4.jpg": 2120,
	"./desk-slider/ds5.jpg": 6594,
	"./desk-slider/news1.jpg": 6590,
	"./desk-slider/news2.webp": 4068,
	"./desk-slider/s1.jpg": 5007,
	"./desk-slider/s2.jpg": 3974,
	"./desk-slider/s3.jpg": 9716,
	"./desk-slider/s4.jpg": 8443,
	"./mob-slider/ns1.jpg": 4210,
	"./mob-slider/ns2.jpg": 6485,
	"./mob-slider/ns3.jpg": 6788,
	"./mob-slider/ns4.jpg": 530,
	"./mob-slider/ns5.jpg": 9506,
	"./mob-slider/s1.jpg": 4911,
	"./mob-slider/s2.jpg": 2340,
	"./mob-slider/s3.jpg": 5385,
	"./mob-slider/s4.jpg": 2218,
	"./rpto.jpg": 6990,
	"./s1.jpg": 3921,
	"./s2.jpg": 6011,
	"./s3.jpg": 3647,
	"./s4.jpg": 1169
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5789;